(function() {
  'use strict';
  
  let skeletonsHidden = false;
  let observer = null;
  let searchaniseFullyRendered = false;

  /**
   * Check if Searchanise is fully rendered with actual content
   * This ensures we don't hide skeleton until content is ready
   * Handles both collection and search pages
   */
  function isSearchaniseFullyRendered() {
    // Check both #snize_results and #search-results for search pages
    const snizeResults = document.querySelector('#snize_results');
    const searchResults = document.querySelector('#search-results');
    
    // Determine which container to check
    const resultsContainer = snizeResults || searchResults?.querySelector('#snize_results');
    if (!resultsContainer) return false;

    // Check for actual product elements with images
    const products = resultsContainer.querySelectorAll('.snize-product');
    if (products.length === 0) {
      // Also check if products are in search-results container directly
      const searchProducts = searchResults?.querySelectorAll('.snize-product');
      if (searchProducts && searchProducts.length > 0) {
        // Check first product image
        const firstProduct = searchProducts[0];
        const firstImage = firstProduct.querySelector('img.snize-item-image');
        if (firstImage && (firstImage.offsetWidth > 0 || firstImage.src || firstImage.srcset)) {
          return true;
        }
      }
      return false;
    }

    // Check if at least the first product has an image loaded or in DOM
    const firstProduct = products[0];
    const firstImage = firstProduct.querySelector('img.snize-item-image');
    
    // If image exists in DOM (even if not fully loaded), consider it rendered
    // This prevents layout shift from skeleton removal
    if (firstImage) {
      // Check if image has dimensions (indicating it's loaded or has dimensions set)
      const hasDimensions = firstImage.offsetWidth > 0 && firstImage.offsetHeight > 0;
      // Also check if image is in viewport or has src/srcset
      const hasSource = firstImage.src || firstImage.srcset || firstImage.dataset.src;
      
      if (hasDimensions || hasSource) {
        // Also check if filter bar is rendered (for mobile especially)
        const isMobile = window.innerWidth <= 820;
        if (isMobile) {
          const mainPanel = document.querySelector('.snize-main-panel:not(.searchanise-skeleton)');
          if (!mainPanel) return false; // Wait for mobile filter bar
        } else {
          const horizontalWrapper = document.querySelector('.snize-horizontal-wrapper:not(.searchanise-skeleton)');
          if (!horizontalWrapper) return false; // Wait for desktop filter bar
        }
        return true;
      }
    }

    // Fallback: check if results container has meaningful content
    return resultsContainer.children.length > 0 && 
           (resultsContainer.querySelector('.snize-search-results-content') || 
            resultsContainer.querySelector('.snize-product'));
  }
  
  function hideSkeletons() {
    if (skeletonsHidden) return;
    skeletonsHidden = true;
    
    // Hide all skeleton types (container, filter bars, mobile panel)
    const skeletons = document.querySelectorAll('.searchanise-skeleton-container, .snize-horizontal-wrapper.searchanise-skeleton, .snize-main-panel.searchanise-skeleton');
    
    // Also find all child skeleton elements (filter buttons, count, etc.)
    const childSkeletons = document.querySelectorAll('.filter-skeleton-button, .filter-skeleton-count, .filter-skeleton-sort, .skeleton-mobile-filter-button, .skeleton-mobile-results-count, .snize-horizontal-left.searchanise-skeleton, .snize-horizontal-right.searchanise-skeleton');
    
    // Hide child skeleton elements immediately (stop animations)
    childSkeletons.forEach(child => {
      child.style.opacity = '0';
      child.style.visibility = 'hidden';
      child.style.animation = 'none'; // Stop pulsing animation
      child.style.pointerEvents = 'none';
    });
    
    skeletons.forEach(skeleton => {
      // Add fade-out class for CSS transition
      skeleton.classList.add('fade-out');
      
      // Stop all animations on this skeleton and its children immediately
      skeleton.style.animation = 'none';
      const allChildren = skeleton.querySelectorAll('*');
      allChildren.forEach(child => {
        child.style.animation = 'none';
        child.style.opacity = '0';
      });
      
      // Use opacity transition instead of display toggle to prevent layout shift
      // Use hardware-accelerated properties for smooth mobile transitions
      skeleton.style.opacity = '0';
      skeleton.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
      skeleton.style.transform = 'translateZ(0)'; // Hardware acceleration
      
      // Keep skeleton in DOM but make it invisible and non-interactive
      // This prevents layout shift by maintaining dimensions
      setTimeout(() => {
        if (skeleton.parentNode) {
          // Use visibility instead of display to maintain layout space
          skeleton.style.visibility = 'hidden';
          skeleton.style.pointerEvents = 'none';
          skeleton.style.position = 'absolute';
          skeleton.style.width = '1px';
          skeleton.style.height = '1px';
          skeleton.style.overflow = 'hidden';
          // Keep min-height to prevent any potential shift
          skeleton.style.minHeight = '0';
          
          // Ensure all children are also completely hidden
          const remainingChildren = skeleton.querySelectorAll('*');
          remainingChildren.forEach(child => {
            child.style.display = 'none';
            child.style.visibility = 'hidden';
            child.style.opacity = '0';
            child.style.animation = 'none';
          });
        }
      }, 300);
    });
    
    // Notify spdn2 if needed
    window.searchaniseReady = true;
    if (typeof window.onSearchaniseReady === 'function') {
      window.onSearchaniseReady();
    }
    
    // Disconnect observer if still active
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }
  
  function checkSearchaniseReady() {
    if (skeletonsHidden) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      return;
    }

    // Check if Searchanise has rendered with actual content
    if (isSearchaniseFullyRendered()) {
      searchaniseFullyRendered = true;
      
      // Wait for layout to be stable before hiding skeleton
      // Use multiple requestAnimationFrame calls for smooth transition, especially on mobile
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // One more frame to ensure everything is painted
          requestAnimationFrame(() => {
            hideSkeletons();
          });
        });
      });
    }
  }
  
  // Watch for Searchanise content with more specific observation
  function setupObserver() {
    if (observer) return; // Already set up
    
    observer = new MutationObserver(function(mutations) {
      // Only check if we haven't hidden skeletons yet
      if (!skeletonsHidden) {
        checkSearchaniseReady();
      } else if (observer) {
        observer.disconnect();
        observer = null;
      }
    });

    // Observe the apps section and results containers for both collection and search pages
    const appsSection = document.querySelector('section[data-section-type="apps"]') ||
                       document.querySelector('section[id*="1728113856f77454f1"]') ||
                       document.querySelector('section[data-section-type="search-template"]') ||
                       document.body;
    
    if (appsSection) {
      observer.observe(appsSection, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'] // Watch for style/class changes that might indicate rendering
      });
    }

    // Observe #snize_results and #search-results if they exist or will exist
    const snizeResults = document.querySelector('#snize_results');
    const searchResults = document.querySelector('#search-results');
    
    if (snizeResults) {
      observer.observe(snizeResults, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
    
    if (searchResults) {
      observer.observe(searchResults, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
    
    if (!snizeResults && !searchResults) {
      // Watch for results containers to be created
      const bodyObserver = new MutationObserver(function() {
        const snizeResults = document.querySelector('#snize_results');
        const searchResults = document.querySelector('#search-results');
        
        if (snizeResults && observer) {
          observer.observe(snizeResults, {
            childList: true,
            subtree: true,
            attributes: true
          });
        }
        
        if (searchResults && observer) {
          observer.observe(searchResults, {
            childList: true,
            subtree: true,
            attributes: true
          });
        }
        
        // If we found at least one, we can disconnect (but keep watching for the other)
        if (snizeResults || searchResults) {
          // Don't disconnect yet - might need to watch for the other container
          // Only disconnect if we're done
          if (skeletonsHidden) {
            bodyObserver.disconnect();
          }
        }
      });
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Set up observer immediately
  setupObserver();
  
  // Also set up when DOM is ready (for mobile Safari)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  }
  
  // Initial check
  checkSearchaniseReady();
  
  // Periodic check for mobile (some mobile browsers have delayed rendering)
  const checkInterval = setInterval(function() {
    if (skeletonsHidden) {
      clearInterval(checkInterval);
      return;
    }
    checkSearchaniseReady();
  }, 500);
  
  // Clear interval after 10 seconds
  setTimeout(function() {
    clearInterval(checkInterval);
  }, 10000);
  
  // Fallback timeout (5 seconds) - but only hide if Searchanise hasn't rendered
  setTimeout(() => {
    if (!skeletonsHidden && !searchaniseFullyRendered) {
      // If Searchanise still hasn't rendered, hide skeleton anyway
      // This prevents skeleton from staying forever
      hideSkeletons();
    }
  }, 5000);
  
  // Expose for coordination with spdn2
  window.hideSkeletons = hideSkeletons;
  window.checkSearchaniseReady = checkSearchaniseReady;
})();
